<div class="onboarding-template">
  <div class="filled-area">
    <ng-content class="image" select="[image]"></ng-content>
    <ng-content class="content" select="[content]"></ng-content>
  </div>
</div>
